// extracted by mini-css-extract-plugin
export default {"curve":"SiteBackgroundCurve_curve"};